module.exports = __webpack_public_path__ + "img/studybridge.c8a07ddf.png";